import type { OneTimeProduct, AssertProduct } from '@/store/products'

declare const _prd_fHjX92z7dCgG: {
	id: 'prd_fHjX92DEV22z7dCgG'
	ident: 'prd_fHjX92z7dCgG'
	sku: 'simple_workbook_bundle_48_usd'
	type: 'one_time'
	price: {
		price_id: 'prc_IhH2x2DEV2apcS2cO'
		amount: 90
		amount_usd: 48
		currency: 'USD'
		amount_with_discount: 48
		discount: 42
		promocode: 'BASE'
	}
}
type _check = AssertProduct<typeof _prd_fHjX92z7dCgG, OneTimeProduct>
const prd_fHjX92z7dCgG = { ident: 'prd_fHjX92z7dCgG' } as typeof _prd_fHjX92z7dCgG

export default prd_fHjX92z7dCgG
